import { DateTime } from 'luxon'
import z from 'zod'

import type { JobTitleID } from '../../job_titles/models/jobTitle'
import type { JobRole as JobRoleDto } from '../../shared/api/generated/models/jobRole'

export const JobRoleID = z.string().brand<'JobRoleID'>()
export type JobRoleID = z.infer<typeof JobRoleID>

/** A kind of work a shift needs done. Employees hold job roles through their job title or a direct grant. */
export interface JobRole {
  id: JobRoleID
  name: string

  /** The job title this role was created alongside, which it shares a name with until one is renamed */
  autoCreatedFromJobTitleId: JobTitleID | null

  archivedAt: DateTime | null

  canManage: boolean

  /** The job titles that grant this role. Only loaded by the job role list. */
  jobTitles?: { id: JobTitleID; name: string }[]
}

export const jobRoleFromDto = (dto: JobRoleDto): JobRole => ({
  id: dto.id as JobRoleID,
  name: dto.name,
  autoCreatedFromJobTitleId:
    (dto.auto_created_from_job_title_id as JobTitleID | null) ?? null,
  archivedAt: dto.archived_at ? DateTime.fromISO(dto.archived_at) : null,
  canManage: dto.permissions?.can_manage ?? false,
  jobTitles: dto.job_titles?.data
    ? dto.job_titles.data.map((title) => ({
        id: title.id as JobTitleID,
        name: title.name,
      }))
    : undefined,
})
